module.exports = __webpack_public_path__ + "static/media/2.bee3269a.jpg";